import React from "react";
import * as styles from "./ContactData.module.scss";
import Socials from "../../UI/Socials/Socials";

const ContactData = () => {
  return (
    <section className={styles.SectionData}>
      <div className={styles.DataContainer}>
        <div className={styles.title}>
          <h6>Datos de contacto</h6>
        </div>
        <div className={styles.ContactData}>
          <p>
            Horarios de atención: <br></br>
            Lunes a Viernes de 8 a 17 hs.
          </p>
          <p className={styles.Link}>
            <a href="mailto:atencion@goldmund.com.ar">atencion@goldmund.com.ar</a>
          </p>
          <p>
            Whatsapp: (+54) 911 2672-6707 <br></br>
            Teléfono: (011) 4452-8951
          </p>
        </div>
        <div className={styles.Socials}>
          <Socials />
        </div>
      </div>
    </section>
  );
};

export default ContactData;
